var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c("div", { staticClass: "dialog-overflow" }, [
        _c("div", { staticClass: "dialog-container" }, [
          _c("div", { staticClass: "dialog" }, [
            _c(
              "div",
              {
                staticClass:
                  "px-4 pt-4 d-flex justify-space-between align-center",
              },
              [
                _c("h3", [_vm._v("Opciones")]),
                _vm._v(" "),
                _c(
                  "button",
                  { on: { click: _vm.closeDialog } },
                  [
                    _c("v-icon", {
                      staticClass: "fas fa-times",
                      attrs: { size: "20", color: "black" },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pa-4" },
              [
                _c(
                  "v-radio-group",
                  {
                    style: { height: "auto", margin: "0px" },
                    attrs: { mandatory: "" },
                    model: {
                      value: _vm.option,
                      callback: function ($$v) {
                        _vm.option = $$v
                      },
                      expression: "option",
                    },
                  },
                  _vm._l(_vm.message.options, function (o, index) {
                    return _c("v-radio", {
                      key: index,
                      staticClass: "red--text",
                      attrs: { value: o },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                o.hidden
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "error",
                                        },
                                      },
                                      [_vm._v(" fas fa-eye-slash")]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  " " + _vm._s(o.title) + "\n            "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary", block: "" },
                    on: { click: _vm.onSelectedOption },
                  },
                  [_vm._v(" Enviar ")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }